<template>
    <span class="status-badge" :class="`bdg-tone-${tone}`">
        <i v-if="icon" :class="icon" class="status-badge__icon"></i>
        <span>{{ label }}</span>
    </span>
</template>

<script>
/**
 * Selo estático de status, para células de tabela.
 *
 * Mesma paleta do `FilterBadge` (`assets/css/badges.css`), forma diferente:
 * aqui o tom pinta fundo, borda e texto, porque a célula não tem espaço para
 * ponto + rótulo + contador e a cor é o próprio dado.
 *
 * Substitui as classes `badge-success`/`badge-danger`/`badge-info` que cada
 * página redeclarava no seu `<style scoped>`. O Bootstrap 5 não tem mais
 * `.badge-<cor>`, então qualquer variante esquecida na cópia local renderizava
 * como texto puro — foi o que aconteceu com o selo "Convertível p/ híbrido",
 * que usava `badge-info` sem ninguém tê-la declarado.
 */
export default {
    name: 'StatusBadge',
    props: {
        label: { type: String, required: true },
        /** Nome do tom da paleta em `assets/css/badges.css` (sem o prefixo). */
        tone: { type: String, default: 'slate' },
        /** Classe de ícone (remixicon). */
        icon: { type: String, default: '' },
    },
};
</script>

<style scoped>
/*
 * A FORMA do selo (`.status-badge`) mora em `assets/css/badges.css`, global, e não
 * aqui: o card do nó no editor de bots é montado como string de HTML (o Drawflow não
 * instancia componentes) e precisa do mesmo selo. Uma cópia local seria a segunda
 * versão que `badges.css` existe para impedir.
 */
</style>
